import React from 'react';
import Head from 'next/head';

import WideLayout from '../../components/layout/wide';
import Title from '../../components/title';
import ImagePanel from '../../components/image-panel';
import { H1 } from '../../components/atoms/typography';

const Contributors = ({ contributors }) => {
  // fixes issue of ampersands not rendering
  const regex = /&amp;/u;

  const getProcessedTwitterUrl = (url) => {
    if (!url) return;
    const twitterPrefix = 'https://twitter.com';
    const lastindexSlash = url.lastIndexOf('/');
    const lastindexAt = url.lastIndexOf('@');

    if (lastindexSlash !== -1) {
      return `${twitterPrefix}/${url.slice(lastindexSlash + 1)}`;
    }

    if (lastindexAt !== -1) {
      return `${twitterPrefix}/${url.slice(lastindexAt + 1)}`;
    }

    return `${twitterPrefix}/${url}`;
  };

  return (
    <>
      <Head>
        <title>{'Contributors'}</title>
      </Head>

      <Title>{'Contributors'}</Title>

      <WideLayout>
        <div className="article">
          <div className="relative bg-white pt-8 pb-20 px-4 sm:px-6 lg:pb-10 lg:px-8">
            <div className="relative max-w-7xl mx-auto pb-14">
              <article className="article">
                <div className="text-center">
                  <H1>{'Contributors'}</H1>
                </div>

                <div className=" content-body mt-3 text-base text-gray-500">
                  <p>
                    {
                      'Fantasy Football Hub brings you the very best fantasy football players, writers, bloggers and content creators under one roof. We already have a brilliant group of contributors signed-up and will be bringing more on in the near future. Here is our team so far:'
                    }
                  </p>
                </div>

                <div className="mt-1 md:mt-6 max-w-lg mx-auto grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-5 divide-y lg:max-w-none">
                  {contributors.map((contributor) => (
                    <ImagePanel
                      id={contributor.id}
                      key={contributor.id}
                      title={contributor.name}
                      imageUrl={contributor.avatar}
                      height={120}
                      width={120}
                      text={contributor.description.replace(regex, '&')}
                      twitterUrl={getProcessedTwitterUrl(contributor.twitter)}
                      buttonUrl={`${process.env.NEXT_PUBLIC_HOSTNAME}/author/${contributor.name}`}
                      buttonText={
                        contributor.postTotal > 1
                          ? `View ${contributor.postTotal} posts`
                          : 'View post'
                      }
                    />
                  ))}
                </div>
              </article>
            </div>
          </div>
        </div>
      </WideLayout>
    </>
  );
};

export const getStaticProps = async () => {
  try {
    const resPage = await fetch(
      `${process.env.NEXT_PUBLIC_MEMBERPRESS_BASE_URL}/wp-json/custom/fetch_contributors`,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': process.env.CONTENT_OFFLOAD_API_KEY || ''
        }
      }
    );

    if (!resPage.ok) {
      console.error('Failed to fetch contributors:', resPage.status);
      return {
        props: { contributors: [] }
      };
    }

    const contributors = await resPage.json();

    return {
      props: { contributors }
    };
  } catch (error) {
    console.error('Error fetching contributors:', error);
    return {
      props: { contributors: [] }
    };
  }
};

export default Contributors;
